import {
  Container,
  Grid,
  IconButton,
  InputAdornment,
  TextField,
  Typography,
  useTheme,
} from "@mui/material";

import { CircuitTabs } from "../CircuitOrganize";
import { BCPLinkSimple } from "../../../components/icons/bcp/BCPIcons";
import { getEnvironmentVariable } from "../../../global/environmentVariables";

export default function CircuitWidgets(props) {
  const { activeTab, handleTabChange, circuit, authContext } = props;

  const theme = useTheme();

  return (
    <Container sx={{ pt: 2, pb: 2 }} maxWidth="lg">
      <Grid container sx={{ gap: 2 }}>
        <Grid
          item
          xs={12}
          sx={{
            p: 2,
          }}
        >
          <Typography variant="h3">{circuit.name}</Typography>

          <CircuitTabs
            circuit={circuit}
            activeTab={activeTab}
            handleTabChange={handleTabChange}
            authContext={authContext}
          />
        </Grid>

        <Grid
          item
          xs={12}
          sx={{
            p: 2,
          }}
        >
          <Grid container spacing={1}>
            {!getEnvironmentVariable("HIDE_RANKINGS") && (
              <Grid item xs={12}>
                <TextField
                  label="Rankings Widget"
                  value={`${window.location.origin}/rankings/${circuit?.id}?embed=true`}
                  variant="outlined"
                  fullWidth
                  margin="normal"
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="Copy Rankings Widget"
                          edge="end"
                          color={
                            theme?.palette?.mode === "dark" ? "" : "primary"
                          }
                          onClick={() => {
                            navigator.clipboard.writeText(
                              `${window.location.origin}/rankings/${circuit?.id}?embed=true`
                            );
                          }}
                        >
                          <BCPLinkSimple />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
            )}
            <Grid item xs={12}>
              <TextField
                label="Calendar Widget"
                value={`${window.location.origin}/circuit/${circuit?.id}/calendar?embed=true`}
                variant="outlined"
                fullWidth
                margin="normal"
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="Copy Calendar Widget"
                        edge="end"
                        color={theme?.palette?.mode === "dark" ? "" : "primary"}
                        onClick={() => {
                          navigator.clipboard.writeText(
                            `${window.location.origin}/circuit/${circuit?.id}/calendar?embed=true`
                          );
                        }}
                      >
                        <BCPLinkSimple />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Container>
  );
}
